var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canShareScreen),expression:"canShareScreen"}],attrs:{"id":"menu-share-screen"}},[_c('i',{staticClass:"icon icon-share"}),_c('span',{staticClass:"bjy-screen-share"})])}
var staticRenderFns = []

export { render, staticRenderFns }